/**
 * This component is not available on web.
 * This mock exists only to prevent runtime crashes
 * before the screen loads in Storybook or tests.
 * No real functionality is implemented.
 */
export default function DatePicker() {
  return null;
}
